"use client";

import { usePathname } from 'next/navigation';
import CitySelector from "@components/organisms/CitySelector";
import VerticalDivider from "@components/atoms/VerticalDivider";

interface CitySelectionHandlerProps {
  showIcon?: boolean;
  showDivider?: boolean;
}

export default function CitySelectionHandler({ 
  showIcon = true, 
  showDivider = true 
}: CitySelectionHandlerProps) {
  const pathname = usePathname();

  // Routes where city selector should be hidden
  const hideCitySelectorRoutes = [
    '/quote/',
    '/cars/deal-confirmation/',
    '/payment-success/'
  ];
  
  const shouldHideCitySelector = hideCitySelectorRoutes.some(route => 
    pathname.startsWith(route) || pathname === route.slice(0, -1)
  );

  if (shouldHideCitySelector) {
    return null;
  }

  return (
    <>
      {showDivider && <VerticalDivider height="20" />}
      <CitySelector showIcon={showIcon} />
    </>
  );
} 